import { render } from "./Chart.vue?vue&type=template&id=6120e7da&scoped=true&ts=true"
import script from "./Chart.vue?vue&type=script&lang=ts"
export * from "./Chart.vue?vue&type=script&lang=ts"

import "./Chart.vue?vue&type=style&index=0&id=6120e7da&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6120e7da"]])

export default __exports__